import React from "react";

const DraftInventory = () => {
  return (
    <div>
      <h3 className="text-lg font-bold">Templates</h3>
      <p>Draft Inventory Content goes here.</p>
    </div>
  );
};

export default DraftInventory;